export const FULLSCREEN_VIDEO_ASPECT_RATIO = 16 / 9;
export const FULLSCREEN_CAMERA_LABEL_HEIGHT = 24;

/** Pack landscape camera tiles across the whole viewport, including partial rows. */
export function getFullscreenGridLayout(cameraCount: number, width: number, height: number) {
  const count = Math.max(1, Math.min(16, Math.floor(cameraCount)));
  const availableWidth = Math.max(1, width);
  const availableHeight = Math.max(FULLSCREEN_CAMERA_LABEL_HEIGHT + 1, height);
  let best = { counts: [count], landscape: false, deviation: Infinity };

  for (let rows = 1; rows <= count; rows++) {
    const pictureHeight = availableHeight - rows * FULLSCREEN_CAMERA_LABEL_HEIGHT;
    if (pictureHeight <= 0) break;
    const counts = Array.from({ length: rows }, (_, row) =>
      Math.floor(count / rows) + (row < count % rows ? 1 : 0));
    const inverseCount = counts.reduce((sum, columns) => sum + 1 / columns, 0);
    const aspectRatio = availableWidth * inverseCount / pictureHeight;
    const landscape = aspectRatio >= 1.5;
    const deviation = Math.abs(Math.log(aspectRatio / FULLSCREEN_VIDEO_ASPECT_RATIO));
    // Prefer landscape pictures, then the arrangement needing the least stretching.
    if ((landscape && !best.landscape) ||
        (landscape === best.landscape && deviation < best.deviation)) {
      best = { counts, landscape, deviation };
    }
  }

  const gcd = (a: number, b: number): number => b === 0 ? a : gcd(b, a % b);
  const columns = best.counts.reduce((tracks, count) => tracks * count / gcd(tracks, count), 1);
  const inverseCount = best.counts.reduce((sum, count) => sum + 1 / count, 0);
  const pictureHeight = availableHeight - best.counts.length * FULLSCREEN_CAMERA_LABEL_HEIGHT;

  return {
    columns,
    // Taller rows with fewer cameras keep picture proportions consistent across rows.
    rowHeights: best.counts.map(count => FULLSCREEN_CAMERA_LABEL_HEIGHT + pictureHeight / count / inverseCount),
    cells: best.counts.flatMap((count, row) => Array.from({ length: count }, () => ({
      row: row + 1, columnSpan: columns / count
    })))
  };
}
